import { DigitInputsAPI, ModalService, PanelAPI, TextAPI } from '@philips-internal/oswald-ui-components';
import Controller, { OnMount, OnReady } from '@philips-internal/oswald-ui-core/lib/client';
import { HttpService, MessageService } from '@philips-internal/oswald-ui-core/lib/services';
import BaseController from '../BaseController';
import { FragmentNames, SecurityAuthenticationInputAppCodeAliases } from '../../codegen';
import { Inject } from '@odinjs/odin';
import { APPLICATION_ENDPOINTS } from '../../constants/application-endpoints';
import { showToastNotificationError, showToastNotificationSuccess } from '../../utils/toast-notification-utils';
import { mfaExpressions, mfaModals } from '../../constants/security-authentication';
import { ReadyEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import { ModalContext } from '../../interfaces/security-authentication';
import { mfaInputMessage } from '../../constants/mfa-messages-constants';

@Controller({ fragment: FragmentNames.SECURITY_AUTHENTICATION_INPUT_APP_CODE })
export default class SecurityActivationInputAppCodeController extends BaseController {

  @Inject(SecurityAuthenticationInputAppCodeAliases.PANEL_LOADER_MFA_AUTHENTICATION)
    panelLoader!: PanelAPI;

  @Inject(SecurityAuthenticationInputAppCodeAliases.TEXT_MFA_INPUT_CODE)
    textMfaInputCodeTextAPI!: TextAPI;

  @Inject(SecurityAuthenticationInputAppCodeAliases.DIGIT_INPUTS_MFA_CODE)
    digitInputsMfaCodeDigitInputsAPI!: DigitInputsAPI;

  @OnReady({ target: SecurityAuthenticationInputAppCodeAliases.DIGIT_INPUTS_MFA_CODE })
  onReadySecurityAuthenticationInputCode(event: ReadyEvent<string>): void {
    const mfaContext = this.context.get('mfaContext') as ModalContext;
    this.panelLoader.setVisible(true);
    let endpoint = '';
    let successMessage = '';
    const body = {
      mfaCode: event.value,
    };

    switch(mfaContext.name){
      case mfaModals.ACTIVATION:
        endpoint = APPLICATION_ENDPOINTS.PUT_VALIDATE_AUTHENTICATION;
        successMessage = mfaExpressions.ACTIVATE_WITH_SUCCESS;
        break;
      case mfaModals.DEACTIVATION:
        endpoint = APPLICATION_ENDPOINTS.PUT_DEACTIVATE_AUTHENTICATION;
        successMessage = mfaExpressions.DEACTIVATION_WITH_SUCCESS;
        break;
    }

    HttpService.put(endpoint, {}, { body })
      .then(() => {
        showToastNotificationSuccess(MessageService.translate(successMessage));
        ModalService.close(mfaModals.MODAL);
      })
      .catch(() => {
        showToastNotificationError(MessageService.translate(mfaExpressions.EXPIRED_INVALID_CODE));
      })
      .finally( () => {
        this.panelLoader.setVisible(false);
        this.digitInputsMfaCodeDigitInputsAPI.clear();
      });
  }

  @OnMount({ target: [
    SecurityAuthenticationInputAppCodeAliases.DIGIT_INPUTS_MFA_CODE,
    SecurityAuthenticationInputAppCodeAliases.TEXT_MFA_INPUT_CODE
  ]})
  onDigitInput(): void {
    const message = mfaInputMessage();
    this.textMfaInputCodeTextAPI.setValue(message);
  }

}
